import * as React from 'react';

import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { ACCEPT_DISCLAIMER, LOGOUT, TOGGLE_DOWNLOAD } from '../store/login';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import { Photo } from '../store/photos';
import { Node, SELECT_PROFILE, COLLAPSE_MENU } from '../store/profile';
import { LOAD_ORDERS } from '../store/webshop';

const mapStateToProps = (state: RootState) => ({
    login: state.login,
    ticket: state.login.ticket,
    photo: state.photo,
    collapsed: state.profile.collapsed,
    num_photos: state.photo.selected.size,
    webshop: state.webshop,
    bricks: state.photo.bricks,
    rendition_type: state.login.rendition_type,
    payment_gateway: state.login.payment_gateway,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    toggleDownload: () => {
        dispatch({ type: TOGGLE_DOWNLOAD })
    },
    toggleFilter: (selected?: number) => {
        dispatch( {type: SELECT_PROFILE, selected})
    },
    loadOrders: () => {
        dispatch({ type: LOAD_ORDERS })
    }
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {
    ids: string[]
}

//let ids: string[]

class Downloads extends React.Component<Props, State> {

    constructor(props: Props){
        super(props);
        this.state = {
            ids: []
        }
        this.props.photo.filters = [];
        this.props.toggleFilter();
    }

    displayPhoto = (photo: Photo) => {

        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let src = `/api/v1/preview/${this.props.rendition_type}/${photo.id}?sbpportal-ticket=${ticket}`;

        let cost = photo.cost == undefined ? 0 : photo.cost as number;


        let title;
        let desc;
        let res;
        let size;

        if(photo.sb_event == undefined){
            photo.sb_event = "";
        }
            title = photo.sb_event.toString().substring(0,100)

        if(photo.sb_year != null){
            desc = photo.sb_year
        }

        if(photo.exif_pixelXDimension != null && photo.exif_pixelYDimension != null){
            res = "Resolution: " + photo.exif_pixelXDimension + "x" + photo.exif_pixelYDimension;
        }

        if(photo.size != null){
            size = (photo.size as number / 1000000).toFixed(2) + " MB" 
        }

        return (
            <tr>
                <td className="selection"><input type="checkbox" placeholder="" id={photo.id} onClick={this.onCheck(photo.id)}></input></td>
                <td className="product-thumbnails"><img src={src} /></td>
                <td className="product-info">
                    <span className="text-muted h6">{desc}</span> - <span className="h6">{title}</span>
                    <ul>
                        <li className="size">{res}</li>
                        <li className="color">{size}</li>
                    </ul>
                </td>
                <td className="direct-download" onClick={this.onDownloadClick(photo.id)}><img src="/assets/icons/download.svg" width="24px" height="auto"></img></td>
            </tr>
                
        )
    }

    onCheck = (id: string) => (e: React.MouseEvent<any>) => {
        let ids = [...this.state.ids]
        const exists = ids.some(v => (v === id));
        if(!exists){
            ids.push(id);
         }else{
             var index = ids.indexOf(id);
             ids.splice(index, 1);
         }
         this.setState({ids: ids})
    }

    onDownloadClick = (id: string) => (e: React.MouseEvent<any>) => {
        e.stopPropagation();
        e.preventDefault();

        let ticket = encodeURIComponent(this.props.ticket || "");

        window.open(`/api/v1/download/original/${id}?sbpportal-ticket=${ticket}`, "_blank");   

    }

    onDownloadAllClick = (cart: Photo[]) => (e: React.MouseEvent<any>) => {
        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let ids = cart.map(photo => photo.id).join(",");

        window.open(`/api/v1/download/original/${ids}?sbpportal-ticket=${ticket}`, "_blank");

        e.stopPropagation();
        e.preventDefault();
    }

    onDownloadSelected = () => (e:React.MouseEvent<any>) => {
        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let ids = this.state.ids.map(photo => photo).join(",");


        window.open(`/api/v1/download/original/${ids}?sbpportal-ticket=${ticket}`, "_blank");

        e.stopPropagation();
        e.preventDefault();
    }

    sortDownloads = (cart: Photo[]) => {

        let sortCart = cart;
        let sortOrder = this.props.webshop.orders;

        let sortedCart: Photo[] = [];

        sortOrder.forEach(function(key) {
            var found = false;
            sortCart = sortCart.filter(function(item) {
                if(!found && item.id == key) {
                    sortedCart.push(item);
                    found = true;
                    return false;
                } else{
                    return true;
                }
            })
        })
        return sortedCart;
    }

    public render() {
        this.props.loadOrders;
        let unSortedCart = this.props.bricks;
        let unSortedComms = this.props.photo.communitybricks;

        unSortedCart = unSortedCart.concat(unSortedComms);

        let cart = unSortedCart.filter(brick => brick.type == "photo" && this.props.webshop.orders.has(brick.id)) as Photo[];

        let sortedCart = this.sortDownloads(cart);
        let downloadSelected;
        if(this.state.ids.length > 0){
           downloadSelected =  <button className="btn btn-download btn-block" onClick={this.onDownloadSelected()}><img className="download_white" src="assets/icons/download.png" height="26px" width="auto" /><img className="download_green" src="assets/icons/download_green.png" height="26px" width="auto"/> Download selected</button>
        }

        if(sortedCart.length == 0){
            return (
                <div className="checkout-section">
                    <div className="container">
                        <div className="checkout-form">
                            <h2 className="main-title">No download available</h2>
                            <div className="mb-80">
                                <a onClick={this.props.toggleDownload} style={{cursor: 'pointer'}} className="text-muted"><img className="checkout-lock" src="assets/icons/chevron_left.png"/> Back to <strong>Gallery</strong></a>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div className="checkout-section">
            <div className="container">
        
                <div className="checkout-form">
                    <div className="row">
                    
                        <div className="col-md-8 cart-list-form mb-150">
        
                        
                            <div className="mb-80">
                                <a onClick={this.props.toggleDownload} style={{cursor: 'pointer'}} className="text-muted"><img className="checkout-lock" src="assets/icons/chevron_left.png"/> Back to <strong>Gallery</strong></a>
                            </div>
        
        
                            <h2 className="main-title">Download</h2>
        
                            <div className="d-block d-sm-block d-md-none float-right pb-30">
                                <button type="button" className="btn btn-sm btn-add-cart"><img className="add-cart-white" src="assets/icons/download.png" height="26px" width="auto"/><img className="add-cart-blue" src="assets/icons/download_blue.png" height="26px" width="auto"/> Download All</button>
                            </div>
        
        
                            <div className="table-responsive">
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            {sortedCart.map(this.displayPhoto)}   
                                        </tr>
                                    </tbody>
                                </table>
                            </div> 
                        </div>
        
                        <div className="col-md-4 d-none d-none d-md-block d-lg-block d-xl-block">
                            <div className="position-fixed">
                                <p>
                                    <button type="button" className="btn btn-add-cart btn-block" onClick={this.onDownloadAllClick(cart)}><img className="add-cart-white" src="assets/icons/download.png" height="26px" width="auto"/><img className="add-cart-blue" src="assets/icons/download_blue.png" height="26px" width="auto"/> Download All</button>
                                </p>
        
                                <p>
                                    {downloadSelected}   
                                </p>
        
                            </div>
                        </div>
        
                        <div className="d-block d-sm-block d-md-none float-right">
                            <div className="fixed-bottom-right">
                                {downloadSelected}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        )

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Downloads);